import { useTranslation } from "react-i18next";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography/Typography";

import { tooltipCardContentStyles } from "../style";

const FinishedStatusChartTooltip = (data: any) => {
  const { t } = useTranslation();
  if (data.payload.length === 0) {
    return null;
  }
  const payload = data.payload[0];
  const titleFont = { color: payload.payload.fill, fontSize: "2vh" };
  const subFont = { color: payload.payload.fill, fontSize: "1.5vh" };
  const cardStyles = { opacity: "0.9" };

  const calculatePercentages = (chartData: any) => {
    const total = chartData.reduce(
      (a: any, b: any) => a + (b["value"] || 0),
      0,
    );
    return `${((payload.value / total) * 100).toFixed(0)}%`;
  };

  const renderTitle = (key: string) => {
    if (key === "ok") {
      return t("label-successful-robot-runs");
    } else if (key === "nok") {
      return t("label-unsuccessful-robot-runs");
    } else {
      return t("label-nan");
    }
  };

  return (
    <Card variant="elevation" elevation={10} style={cardStyles}>
      <CardContent sx={tooltipCardContentStyles}>
        <Typography variant="h1" style={titleFont}>
          {renderTitle(payload.name)}
        </Typography>
        <Typography variant="h2" style={subFont}>
          {t("label-percentage-share")}: {calculatePercentages(data.data)}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default FinishedStatusChartTooltip;
